import styled from "styled-components";
import PageTemplate from "../component/PageTemplate.tsx";
import ImgBanner from "../assets/img/introduction/banner.png";
import ImgSign from "../assets/img/introduction/company/sign.png";
import { useContext } from "react";
import { WrapperContext } from "../component/WrapperContext.tsx";

const Main = styled.div`
  width: 100%;
  height: 100%;
  text-align: left;
  padding: ${(props) => (!props.isMobile ? "25px 0 60px 30px" : "25px 0 30px 0")};
`;

const Description1 = styled.span`
  font-family: SCDream7;
  font-size: 25px;
  line-height: 35px;
`;
const Description2 = styled.span`
  font-family: SCDream5;
  font-size: 16px;
  line-height: 30px;
`;
const SignWrapper = styled.div`
  text-align: right;
  margin-top: 20px;
`;
const Sign = styled.img`
  width: 300px;
`;

export default function Introduction() {
  const { isMobile } = useContext(WrapperContext);

  return (
    <PageTemplate bannerImage={ImgBanner}>
      <Main isMobile={isMobile}>
        <Description1>회사 소개 타이틀</Description1>
        <br /> <br />
        <Description2>
          회사소개를 넣는 곳입니다. 회사소개를 넣는 곳입니다. 회사소개를 넣는 곳입니다. 회사소개를 넣는 곳입니다. 회사소개를 넣는 곳입니다. 회사소개를
          넣는 곳입니다. 회사소개를 넣는 곳입니다. 회사소개를 넣는 곳입니다. 회사소개를 넣는 곳입니다. 회사소개를 넣는 곳입니다. 회사소개를 넣는
          곳입니다. 회사소개를 넣는 곳입니다. 회사소개를 넣는 곳입니다.
          <br />
          <br />
          감사합니다.
        </Description2>
        <SignWrapper>
          <Sign src={ImgSign} />
        </SignWrapper>
      </Main>
    </PageTemplate>
  );
}
